export default __webpack_public_path__ + "static/MarlonWoods-27c64f2350f42e09d363db54df752db7.png";